export const NETWORK_INIT = "NETWORK_INIT";
export const NETWORK_INIT_SUCCESS = "NETWORK_INIT_SUCCESS";
export const NETWORK_INIT_ERROR = "NETWORK_INIT_ERROR";